const normalizeInput = (input, lowercase) => {
    const clean = input.toString().replace(/[^a-zA-Z0-9,\-:]/g, '');
    return lowercase ? clean.toLowerCase() : clean;
}
